import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import usePlayerSelector from '../../../utils/usePlayerSelector';
import { useOktaQuery, Team, KeyTakeaway } from '../../../data';
import KeyTakeawayComponent from '../../../components/KeyTakeaway';
import MatchupPitcherSelector from '../Player/MatchupPitcherSelector';

const DugoutTeamKeyTakeaways = ({ match: { params: { teamId: vsTeamId } }, playerTeamStartingPitchers }) => {
    const { t: translate } = useTranslation();
    const playerUser = usePlayerSelector();
    const [selectedPitcher, setSelectedPitcher] = useState(!playerUser.IsPitcher && playerTeamStartingPitchers?.length
        ? { ...playerTeamStartingPitchers[0], name: playerTeamStartingPitchers[0].FullName, value: playerTeamStartingPitchers[0].PlayerID }
        : {});
    const { Throws: throws } = (!playerUser.IsPitcher ? (selectedPitcher || {}) : playerUser);

    const { data: lineup } = useOktaQuery(['lineup', vsTeamId, 'batter'], (t) => Team.lineup(t, vsTeamId, true));

    return (
        <>
            {!playerUser.IsPitcher && (
                <div className="d-flex align-items-center justify-content-end mb-3">
                    <b className="me-1">{translate('common.select-a-pitcher')}:</b>
                    <MatchupPitcherSelector
                        onSelect={setSelectedPitcher}
                    />
                </div>
            )}
            {(playerUser.IsPitcher || selectedPitcher) && lineup?.map((pl) => <LineupPlayerKTs key={pl.PlayerID} playerid={pl.PlayerID} throws={throws} />)}
        </>
    );
};

const LineupPlayerKTs = ({ playerid, throws }) => {
    const { data: keyTakeaways } = useOktaQuery(
        ['KeyTakeaways', { playerid }],
        (t) => KeyTakeaway.getByPlayer(t, playerid),
    );
    return keyTakeaways?.filter((kt) => kt.ShowToHand === null || kt.ShowToHand === throws).map((kt) => (
        <KeyTakeawayComponent key={kt.TakeawayID} takeaway={kt} showPlayerName isOpen={false} />
    )) ?? null;
};

DugoutTeamKeyTakeaways.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            teamId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        }).isRequired,
    }).isRequired,
    playerTeamStartingPitchers: PropTypes.arrayOf(PropTypes.shape({
        PlayerID: PropTypes.number.isRequired,
        FullName: PropTypes.string.isRequired,
    })),
};
DugoutTeamKeyTakeaways.defaultProps = {
    playerTeamStartingPitchers: [],
};

export default DugoutTeamKeyTakeaways;
